import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'search-no_results_in_search-view';

/**
 * Fired when a user views a search page with no search results
 */
export function trackSearchNoResultsInSearchView(
  Saved_filters: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { Saved_filters },
  });
}
